export default __webpack_public_path__ + "f84b476995a8496adce24ec672244eafc9a43686/4a3dbbaeebd81c970f39dfd9033ad55f.png";